import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7324e964"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "text-center" }
const _hoisted_2 = {
  class: "spinner-border spinner-border-sm text-light",
  role: "status",
  style: {"margin-right":"0.5rem"}
}

import { reactive, ref, watch } from 'vue';
  import { userSurveysStore } from '@/stores';
  import { FormItem } from '@/types/form';
  import { Responses  } from '@/types/responses';
  import { ISurvey  } from '@/types/survey';
  import { getQuestions, getAnswers } from '@/utils';
  import { useI18n } from 'vue-i18n';
  import _ from 'lodash';
  import dayjs from 'dayjs';
  import { useToast } from 'bootstrap-vue-3';
  import { ColorVariants } from '@/constants';

  
export default /*#__PURE__*/_defineComponent({
  setup(__props) {

  const { t } = useI18n();
  const toast = useToast();

  let form = reactive({});
  const disabled = ref(false);
  const formList = reactive<FormItem[]>([]);
  let startTime = dayjs().toISOString();

  watch(() => userSurveysStore.showModal, (val) => {
    // 每次显示问卷，需要将上一次答题清空
    if (val) {
      _.forEach(form, (key) => {
        delete form[key];
      });
      startTime = dayjs().toISOString();
    }
  });

  watch(() => userSurveysStore.data, data => {
    formList.splice(0, formList.length, ...getQuestions(data));
  }, { immediate: true });

  function formItemChange(data: any) {
    form[data.key] = data.value;
  }

  const handleSubmit = async () => {
    try {
      disabled.value = true;
      const { id } = (userSurveysStore.data as ISurvey);
      const body: Responses = {
        survey_id: id,
        type: 'SurveyResponse',
        started_at: startTime,
        completed_at: dayjs().toISOString(),
        answers_attributes: getAnswers(form, formList)
      };
      await userSurveysStore.submit(body);
      toast.show({ title: t('Success'), body: t('Submit success!') }, { variant: ColorVariants.success });
    } finally {
      disabled.value = false;
    }
  };

return (_ctx: any,_cache: any) => {
  const _component_AppFormGroupItem = _resolveComponent("AppFormGroupItem")!
  const _component_b_button = _resolveComponent("b-button")!
  const _component_b_form = _resolveComponent("b-form")!
  const _component_AppDialog = _resolveComponent("AppDialog")!

  return (_openBlock(), _createBlock(_component_AppDialog, {
    visible: _unref(userSurveysStore).showModal,
    "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((_unref(userSurveysStore).showModal) = $event)),
    class: "page",
    title: _unref(userSurveysStore).data.title,
    btns: [],
    onConfirm: handleSubmit
  }, {
    default: _withCtx(() => [
      _createVNode(_component_b_form, {
        class: "question-wrapper",
        onSubmit: handleSubmit
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(formList), (item) => {
            return (_openBlock(), _createElementBlock("div", {
              key: item.key,
              class: "form-group-item"
            }, [
              _createVNode(_component_AppFormGroupItem, {
                config: item,
                form: _unref(form),
                onChange: formItemChange
              }, null, 8, ["config", "form"])
            ]))
          }), 128)),
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_b_button, {
              type: "submit",
              pill: "",
              variant: "primary",
              disabled: disabled.value,
              class: "submit-btn"
            }, {
              default: _withCtx(() => [
                _withDirectives(_createElementVNode("div", _hoisted_2, null, 512), [
                  [_vShow, disabled.value]
                ]),
                _createTextVNode(" " + _toDisplayString(_unref(t)('Submit')), 1)
              ]),
              _: 1
            }, 8, ["disabled"])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["visible", "title"]))
}
}

})